var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',{staticClass:"article-detail__title"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"md-content",domProps:{"innerHTML":_vm._s(_vm.markdown)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }